/* Surface filter chips — Search & Discovery filters, applied in place.
 *
 * The chips (snippets/surface-filter.liquid) are plain links to Shopify's own
 * filter URLs (`?filter.p.m.custom.built_for=Carpet`), so without this script
 * a chip is an ordinary page load. With it, a click fetches the same URL from
 * the Section Rendering API (`section_id=<the section's id>`), swaps the parts
 * of the page that change, and pushes the URL, as Dawn's assets/facets.js
 * does. Back and forward re-render from the address bar.
 *
 * Markup contract:
 *   [data-shop-filters][data-section-id]  the root; one per page
 *   a[data-filter-link][data-filter-key]  a chip; its href is the filter URL
 *   [data-filter-region="name"]           replaced by the fetched region of
 *                                         the same name
 *   [data-result-label]                   outside every region; its content
 *                                         is updated in place, so its
 *                                         aria-live announces the count
 * A chip whose href points at another origin is left to the browser.
 * If the fetched root lacks a region the page has, the root's whole content
 * is swapped instead. A failed or unparseable response falls back to a normal
 * navigation to the link, so a chip always does something.
 *
 * Until 2026-09-14 this file showed and hid server-rendered rows by a
 * hand-picked group key. Listeners sit on document, so a section the theme
 * editor or this script re-renders needs no re-binding; loading the file
 * twice binds once. After a swap it fires `smb:section:refresh` on the root
 * so smb-loadmore.js wires the new Load more link.
 */
(function () {
  if (window.__smbShopFilter) return;
  window.__smbShopFilter = true;

  var ticket = 0;
  var primed = false;

  function sectionUrl(href, id) {
    var u = new URL(href, window.location.href);
    u.searchParams.set('section_id', id);
    return u.pathname + u.search;
  }

  function regionOf(scope, name) {
    var all = scope.querySelectorAll('[data-filter-region]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-filter-region') === name) return all[i];
    }
    return null;
  }

  function swap(root, fresh) {
    var regions = Array.prototype.slice.call(root.querySelectorAll('[data-filter-region]'));
    var pairs = regions.map(function (r) {
      return [r, regionOf(fresh, r.getAttribute('data-filter-region'))];
    });
    var whole =
      !pairs.length ||
      pairs.some(function (p) {
        return !p[1];
      });
    var label = root.querySelector('[data-result-label]');
    var freshLabel = fresh.querySelector('[data-result-label]');
    if (whole) {
      root.innerHTML = fresh.innerHTML;
      return;
    }
    pairs.forEach(function (p) {
      p[0].parentNode.replaceChild(p[1], p[0]);
    });
    // The label element stays, and only what it holds changes, so its
    // aria-live announces the new count. Search's label wraps a paragraph
    // (or nothing, when a search found nothing), so its content is copied,
    // not just its text.
    if (label && freshLabel) label.innerHTML = freshLabel.innerHTML;
  }

  function refocus(root, key) {
    if (!key) return;
    var links = root.querySelectorAll('[data-filter-link]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('data-filter-key') === key) {
        links[i].focus();
        return;
      }
    }
  }

  function render(root, href, push, key) {
    var mine = ++ticket;
    root.setAttribute('aria-busy', 'true');
    return fetch(sectionUrl(href, root.getAttribute('data-section-id')), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (mine !== ticket) return; // a later click owns the page now
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shop-filters]');
        if (!fresh) throw new Error('no [data-shop-filters] in the response');
        swap(root, fresh);
        root.removeAttribute('aria-busy');
        if (push) window.history.pushState({ smbShopFilter: true }, '', href);
        root.dispatchEvent(new CustomEvent('smb:section:refresh', { bubbles: true }));
        refocus(root, key);
      })
      .catch(function () {
        if (mine !== ticket) return;
        window.location.assign(href);
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest('a[data-filter-link]') : null;
    if (!link) return;
    var root = link.closest('[data-shop-filters]');
    if (!root || !root.getAttribute('data-section-id')) return;
    if (!window.fetch || !window.DOMParser || !window.history || !window.history.pushState) return;
    // Only this storefront's own pages are fetched in place; a link to any
    // other origin is left to the browser.
    var target;
    try {
      target = new URL(link.getAttribute('href'), window.location.href);
    } catch (err) {
      return;
    }
    if (target.origin !== window.location.origin) return;
    e.preventDefault();
    // Mark the entry we are leaving, so Back to it re-renders too. Whatever
    // another script already keeps in that entry's state is kept.
    if (!primed) {
      window.history.replaceState(Object.assign({}, window.history.state, { smbShopFilter: true }), '');
      primed = true;
    }
    render(root, link.getAttribute('href'), true, link.getAttribute('data-filter-key'));
  });

  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.smbShopFilter) return;
    var root = document.querySelector('[data-shop-filters][data-section-id]');
    if (!root) return;
    render(root, window.location.href, false, null);
  });
})();
